/** cspell:disable */

//TODO: update this interface when migrate service to V2
export interface IWhatsAppInfoResponseV1 {
  elementoId: number;
  dia: string;
  mes: string;
  anio: string;
  hora: string;
  minutos: string;
  inmediato: boolean;
  refuerzo: boolean;
  desde: string;
  destinatarios: null | unknown[];
  mensaje: string;
  campo: number;
}

//TODO: update this interface when migrate service to V2
interface GroupRecipientsV1 {
  id: string;
  nombre: string;
  tipo: string;
}

export interface IWhatsAppRecipientsResponseV1 {
  elementoId: number;
  grupos: GroupRecipientsV1[];
  listas: unknown[];
}

export interface IWhatsAppReportActionResponseV1 {
  elementoId: number;
  elementoEnvioId: number;
  configuracion: boolean;
  activo: boolean;
  estado: string;
  elementoSmsId: number;
  agruparContactos: boolean;
  campoId: number;
  campoNombre: string;
  grupoId: number;
  grupoNombre: string;
  codigoPais: string;
  enviados: string;
  fecha_envio: string;
  envio_inmediato: boolean;
  destinatarios: boolean;
  tiene_mensaje: boolean;
  fallidos: string;
  depurados: string;
  cantidad_clicks: string;
  pendings: string;
  total: string;
  sent: string;
  delivery_rate: string;
  tipo: string;
  remarketing: boolean;
  contieneErrores: boolean;
  enviarActualizado: boolean;
  touch_rules: boolean;
  nombre: string;
  campaniaNombre: string;
  campaniaId: number;
}

export interface IWhatsAppInfoPayload {
  elementoId: number;
  campoId: number;
  mensaje: string;
  track: boolean;
}

export interface IScheduledWhatsAppDeliveryV1 {
  elementoId: number;
  minuto: number;
  hora: number;
  milis: number;
  force_cache?: number;
}

export interface IReportParams {
  clave: string;
  valor: string;
}

/** cspell:enable */

export interface MessageStateWhatsApp {
  original: string;
  shortened: string;
  track: boolean;
  length: number;
  count: number;
  customFields: number;
}

export type UpdateTypeStateWhatsApp = Partial<Omit<MessageStateWhatsApp, 'length' | 'count'>>;

// cspell:disable
export interface IRecipientsWhatsAppByType {
  id: number | string;
  nombre: string;
  tipo: number | string;
}
// cspell:enable

// cspell:disable
export interface IListRecipientsWhatsAppByType {
  ['INTERES']: IRecipientsWhatsAppByType[];
  ['PERFIL']: IRecipientsWhatsAppByType[];
  ['USUARIO']: IRecipientsWhatsAppByType[];
  ['INTEGRACION']: IRecipientsWhatsAppByType[];
}
// cspell:enable

export const WHATSAPP_ACTION_TYPES = {
  QUICK_REPLY: 'QUICK_REPLY' as const,
  URL: 'URL' as const,
  PHONE_NUMBER: 'PHONE_NUMBER' as const,
  VOICE_CALL: 'VOICE_CALL' as const,
  COPY_CODE: 'COPY_CODE' as const,
} as const;

export type WhatsAppActionType = (typeof WHATSAPP_ACTION_TYPES)[keyof typeof WHATSAPP_ACTION_TYPES];

export interface WhatsAppActionBase {
  type: WhatsAppActionType;
  title: string;
}

export interface QuickReplyAction extends WhatsAppActionBase {
  type: typeof WHATSAPP_ACTION_TYPES.QUICK_REPLY;
  id: string;
}

export interface UrlAction extends WhatsAppActionBase {
  type: typeof WHATSAPP_ACTION_TYPES.URL;
  url: string;
}

export interface PhoneAction extends WhatsAppActionBase {
  type: typeof WHATSAPP_ACTION_TYPES.PHONE_NUMBER;
  phone: string;
}

export interface VoiceCallAction extends WhatsAppActionBase {
  type: typeof WHATSAPP_ACTION_TYPES.VOICE_CALL;
  ttl_minutes: number;
}

export interface CopyCodeAction extends WhatsAppActionBase {
  type: typeof WHATSAPP_ACTION_TYPES.COPY_CODE;
  code: string;
}

export type WhatsAppAction =
  | QuickReplyAction
  | UrlAction
  | PhoneAction
  | VoiceCallAction
  | CopyCodeAction;

export type WhatsAppCardTemplate = {
  body: string;
  media: string[];
  header_text: string;
  footer: string;
  actions: WhatsAppAction[];
};

export type TwilioTextTemplate = {
  body: string;
};

export type TwilioMediaTemplate = {
  body: string;
  media: string[];
};

export type TemplateType = TwilioTextTemplate | TwilioMediaTemplate | WhatsAppCardTemplate;

export type TemplateKey = 'twilio/text' | 'twilio/media' | 'whatsapp/card';
export interface IWhatsAppTemplate {
  to: string;
  from: string;
  ContentSid: string; // TODO: modify to use content_sid
  friendly_name: string;
  language: string;
  variables: Record<string, string>;
  types: {
    [key in TemplateKey]?: TemplateType;
  };
}
